import { useConfigurations } from '@openeducation/hr-rn-components';
import { ExternalPortalExperienceType } from '@openeducation/hr-rn-shared-types';
import { useEffect } from 'react';

import { OEPath, OMPath, Path, useLocation, useNavigate } from '../router';

/**
 * Keeps external-portal-only users (Spotfire experience) on /external-portal: any other private
 * path — deep link, bookmark, back navigation — redirects there. The inverse guard lives in the
 * external-portal screen (non-Spotfire users are sent back to /choice). Admin paths are exempt
 * so admin-mode sessions impersonating a Spotfire purchaser keep their tooling reachable.
 */
const EXEMPT_PATHS: string[] = [
  Path.ExternalPortal,
  OEPath.Admin,
  OMPath.Admin,
];

export const useExternalPortalGuard = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { externalPortalExperience, configurationsLoading } =
    useConfigurations();

  useEffect(() => {
    if (
      configurationsLoading ||
      externalPortalExperience?.type !==
        ExternalPortalExperienceType.SPOTFIRE ||
      EXEMPT_PATHS.includes(pathname)
    ) {
      return;
    }

    navigate(Path.ExternalPortal, { replace: true });
  }, [
    configurationsLoading,
    externalPortalExperience?.type,
    pathname,
    navigate,
  ]);
};
